import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MenuService } from 'app/services/menu.service';

@Component({
  selector: 'resource-menu',
  templateUrl: './resource-menu.component.html',
  standalone: false,
})
export class ResourceMenuComponent {
  @Input() resources;
  @Input() menuId;
  @Input() title;
  @Output() closeMenuEvent = new EventEmitter<boolean>();
  constructor(private menuService: MenuService) {}

  closeMenu() {
    this.closeMenuEvent.emit(true);
  }
}
